module.exports = __webpack_public_path__ + "img/wallet-connect.d42cf482.svg";